import { DEFAULT_DESIGN_LIST_LIMIT } from '@repo/api-contracts';
import { useInfiniteQuery } from '@tanstack/react-query';
import { trpc } from '@/shared/api';
import { MY_DESIGNS_QUERY_KEY } from './my-designs-query-key';

/**
 * 내 디자인 목록(designs.list) — 최근 수정순 keyset 페이지. "더 보기"가 다음 커서를 읽는다.
 * tRPC 의 useInfiniteQuery 는 입력에 direction 을 덧붙이는데 계약(listDesignsInputSchema)이 strict 라 거부된다 —
 * 그래서 TanStack useInfiniteQuery 에 tRPC 클라이언트 호출을 직접 물려 계약 그대로({ limit, cursor })만 보낸다.
 */
export const useMyDesignsQuery = () => {
  const utils = trpc.useUtils();

  return useInfiniteQuery({
    queryKey: MY_DESIGNS_QUERY_KEY,
    queryFn: ({ pageParam }) =>
      utils.client.designs.list.query(
        pageParam === null
          ? { limit: DEFAULT_DESIGN_LIST_LIMIT }
          : { limit: DEFAULT_DESIGN_LIST_LIMIT, cursor: pageParam },
      ),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
  });
};
